import { pageLayout } from '~/utils/layout'

import { BackgroundWrapper } from './background'
import { PageContent } from './PageContent'

export interface PageLayoutWithoutHeaderProps {
  children: React.ReactNode
  background?: React.ReactElement
}

export const PageLayoutWithoutHeader = ({
  children,
  background,
}: PageLayoutWithoutHeaderProps) => {
  return (
    <div className={pageLayout}>
      {background && <BackgroundWrapper>{background}</BackgroundWrapper>}
      <PageContent>{children}</PageContent>
    </div>
  )
}
